import { styled } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';

export const IconStyled = styled('div')(({ theme }) => ({
  color: theme.palette.tertiary.main,
}));

interface IconHeaderProps {
  Icon: React.ComponentType<SvgIconProps>;
}

export const IconHeader: React.FC<IconHeaderProps> = ({ Icon }) => {
  return (
    <IconStyled>
      <Icon />
    </IconStyled>
  );
};
